let Modernizr = require("../../vendors/modernizr.min");
let $ = require("jquery");

$(function () {
    let desktopMq = "(min-width: 992px)",
        tabletMq = "(min-width: 768px)",
        mobileMq = "(max-width: 993px)",
        activeClass = "ws-accordion__header--active",
        inactiveClass = "ws-accordion__header--inactive",
        fadeAnimationClass = "ws-accordion--animation_fade",
        adaptiveLayoutClass = "ws-accordion--layout_adaptive",
        openLayoutClass = "ws-accordion--layout_open",
        eagleAccordionClass = "ws-eagle-map__accordion",
        accordionContentSelector = ".ws-accordion__content, .ws-accordion__faq-content",
        accordionTextContentSelector = ".ws-accordion__text",
        $faqAccordions = $(".ws-accordion__faq .ws-accordion__header");
    
    let accHeaderSelector = ".ws-accordion__header:not(.ws-accordion__header-faq)",
          //use the summary hide/show logic on the faq page, where the summary html element is styled with the accordion__header class.
          accSummarySelector = ".ws-accordion__summary, .ws-accordion__header.ws-accordion__header-faq";

    let animateAccordion = function ($target) {
        let $slideTarget = $target.siblings(accordionContentSelector);
        let $parent = $target.parent();

        if ($target.hasClass(activeClass)) {
            if ($parent.hasClass(eagleAccordionClass) && window.innerWidth < 992) {
                $target.text("Filters");
            }
            animateAccordionClose($target, $parent, $slideTarget);
        }
        else if ($target.hasClass(inactiveClass) || !$parent.hasClass(adaptiveLayoutClass)) {
            if ($parent.hasClass(eagleAccordionClass) && window.innerWidth < 992) {
                $target.text("Close");
            }

            animateAccordionOpen($target, $parent, $slideTarget);
        }
        else if ($parent.hasClass(adaptiveLayoutClass)) {
            // accordion is adaptive, meaning it defaults to open or closed based on the viewport, but hasn't been toggled by the user yet
            if (adaptiveAccordionMatchesBreakpoint($target)) {
                if ($parent.hasClass(eagleAccordionClass) && window.innerWidth < 992) {
                    $target.text("Filters");
                }

                $slideTarget.css('display', 'block');
                $target.addClass(activeClass);
                requestAnimationFrame(() => animateAccordionClose($target, $parent, $slideTarget));
            }
            else {
                if ($parent.hasClass(eagleAccordionClass) && window.innerWidth < 992) {
                    $target.text("Close");
                }

                animateAccordionOpen($target, $parent, $slideTarget);
            }
        }
    };

    let animateAccordionOpen = function ($target, $parent, $slideTarget) {
        $target.removeClass(inactiveClass);
        $target.addClass(activeClass);

        if ($parent.hasClass(fadeAnimationClass)) {
            $slideTarget.fadeIn(100, () => scrollWindowIfContentHidden($target));
        }
        else {
            $slideTarget.stop().slideDown(() => scrollWindowIfContentHidden($target));
        }
    };

    let animateAccordionClose = function ($target, $parent, $slideTarget) {
        $target.removeClass(activeClass);
        $target.addClass(inactiveClass);

        if ($parent.hasClass(fadeAnimationClass)) {
            $slideTarget.fadeOut(100, () => $slideTarget.css("display", ""));
        }
        else {
            $slideTarget.stop().slideUp(() => $slideTarget.css("display", ""));
        }
    };

    let showHideAccordion = function ($target) {
        let $toggleTarget = $target.siblings(accordionContentSelector);
        let $parent = $target.parent();

        if ($target.hasClass(activeClass)) {
            hideAccordion($target, $toggleTarget);
        }
        else if ($target.hasClass(inactiveClass) || !$parent.hasClass(adaptiveLayoutClass)) {
            showAccordion($target, $toggleTarget);
        }
        else if ($parent.hasClass(adaptiveLayoutClass)) {
            // accordion is adaptive, meaning it defaults to open or closed based on the viewport, but hasn't been toggled by the user yet
            if (adaptiveAccordionMatchesBreakpoint($target)) {
                hideAccordion($target, $toggleTarget);
            }
            else {
                showAccordion($target, $toggleTarget);
            }
        }
    };

    let showAccordion = function ($target, $toggleTarget) {
        $target.addClass(activeClass);
        $target.removeClass(inactiveClass);
        $toggleTarget.show();
    };

    let hideAccordion = function ($target, $toggleTarget) {
        $target.addClass(inactiveClass);
        $target.removeClass(activeClass);
        $toggleTarget.hide();
    };

    function scrollWindowIfContentHidden($target) {
        //check if target is contained in an accordion tree.
        if ($target.parents('div.ws-accordion__tree').length) {
            //if it is contained in an accordion tree, 
            //then check that the expanded content is not below the fold of the 
            let $accordionContent = $target.siblings('.ws-accordion__content');
            //if the content is below the page fold then return by how many pixels
            let belowPageFold = amountBelowFold($accordionContent);
            if (belowPageFold) {

                let extraSpacing = 10;
                let $headerHeight = $('header.ws-nav').outerHeight();
                let $windowHeight = $(window).height();
                //if the content height is greater than the viewport of the page then don't let the accordion header
                //scroll past the page header.
                if ($accordionContent.outerHeight() >= ($windowHeight - $headerHeight)) {
                    belowPageFold = belowPageFold -
                        ($accordionContent.outerHeight() - ($windowHeight - $headerHeight - $target.outerHeight() - (extraSpacing*2)));
                }
                $('html, body').animate({ scrollTop: '+='+(belowPageFold + extraSpacing + $headerHeight)}, 150);
            }
        }
    };

    function amountBelowFold($target) {
        let belowPageFold = 0;
        let docViewTop = $(window).scrollTop();
        let docViewBottom = docViewTop + $(window).height();

        let elemTop = $target.offset().top;
        let elemBottom = elemTop + $target.height();

        if (elemBottom >= docViewBottom) {
            belowPageFold = elemBottom - docViewBottom;
        }

        return belowPageFold;
    }

    let toggleAccordion = function (e) {
        let $this = $(this),
              $parent = $this.parent();

        if (!(Modernizr.mq(desktopMq) && $parent.hasClass(openLayoutClass))) {
            animateAccordion($this);
        }

        $this.trigger({
            type: $this.hasClass(activeClass) ? "ws-accordion-open" : "ws-accordion-close",
            originalEvent: e
        });
    };

    let toggleAccordionSummary = function () {
        let $this  = $(this);
        let $details = $this.parent(".ws-accordion__details");
        let open = $details.attr("open");

        if (!open) {
            $details.attr("open", "open");
        }

        //todo consider using slideToggle options object to handle responsive flex summary toggle
        /*
        NOTE: If your accordion content is anything other than block (e.g. "display: flex"),
        then you may need to set this as inline style to avoid animation interrupt
        */
        $this.siblings(accordionTextContentSelector).slideToggle(function () {
            if (open) {
                $details.removeAttr("open");
            }
        });

        if ($this.hasClass("ws-accordion__header") && $this.hasClass(activeClass)) {
            $this.removeClass(activeClass);
            $this.addClass(inactiveClass);
        }
        else if ($this.hasClass("ws-accordion__header")) {
            $this.removeClass(inactiveClass);
            $this.addClass(activeClass);
        }
    };

    $(document).on("click", accHeaderSelector, toggleAccordion);

    if (!WS.isExperienceEditor()) {
        $(document).on("keydown keyup", accHeaderSelector, function (e) {
            let key = e.which || e.keyCode;

            if ((e.type === "click" || key === 13 || key === 32)) {
                // 13 is enter 32 is space.  This will allow for consistant functionality  that is
                // built into the <details><summary> markup which is used by the Single Accordion.
                e.preventDefault();

                if (e.type === "keydown") {
                    return;
                }

                let toggleAccordionBoundWithThis = toggleAccordion.bind(this, e);
                toggleAccordionBoundWithThis();
            }
        });

        $(accSummarySelector).on("click keydown keyup", function (e) {
            let key = e.which || e.keyCode;

            if ((e.type === "click" || key === 13 || key === 32)) {
                // 13 is enter 32 is space.  This will allow for consistent functionality  that is
                // built into the <details><summary> markup which is used by the Single Accordion.
                e.preventDefault();

                if (e.type === "keydown") {
                    return;
                }

                let toggleAccordionSummaryBoundWithThis = toggleAccordionSummary.bind(this);
                toggleAccordionSummaryBoundWithThis();
            }
        });
    }
    else if ($faqAccordions.length) {
        // open FAQ accordions for Experience Editor
        $faqAccordions.each(function (index) {
            let $details = $(this).parent(".ws-accordion__details");
            let open = $details.attr("open");

            if (!open) {
                $details.attr("open", "open");
            }
            $(this).siblings(accordionTextContentSelector).slideToggle(function () {
                if (open) {
                    $details.removeAttr("open");
                }
            });
        });
    }

    function adaptiveAccordionMatchesBreakpoint($accordion) {
        let breakpoint = $accordion.parent().data("breakpoint"),
            breakpointMq = breakpoint === "tablet" ? tabletMq : desktopMq;
        return Modernizr.mq(breakpointMq);
    }

    let $closedAccordionsBeforePrint;

    function beforePrint() {
        $closedAccordionsBeforePrint = $("details:not([open])").attr("open", "");
    };

    function afterPrint() {
        if (!$closedAccordionsBeforePrint) {
            return;
        }

        $closedAccordionsBeforePrint.removeAttr("open");
    };

    // Webkit
    if (window.matchMedia) {
        let mediaQueryList = window.matchMedia("print");
        mediaQueryList.addListener(function (mql) {
            if (mql.matches) {
                beforePrint();
            }
            else {
                afterPrint();
            }
        });
    }

    // IE, Firefox
    window.onbeforeprint = beforePrint;
    window.onafterprint = afterPrint;

    exports.animateAccordion = animateAccordion;
});